import { RealtyObjectType } from '@search/filter-enums/enums/RealtyObjectType';
import { ISearchType } from '@search/offer-search-routes/src';

export function offerSearchTextCategoryType({
    categoryType
}: {
    categoryType: ISearchType['categoryType'];
}) {
    switch (categoryType) {
        case RealtyObjectType.FLAT:
            return 'квартиру';

        case RealtyObjectType.ROOM:
            return 'комнату';

        case RealtyObjectType.LAND:
            return 'участок';

        case RealtyObjectType.HOUSE:
            return 'дом';

        default:
            return 'комнату';
    }
}
